import { DataListOption } from "src/api/sure-api/dataList/useGetAllDataList";
import { DeleteProperty } from "src/api/client-api/property/useDeleteProperty";
import { getOptionCodes, getOptionValue } from "src/utils/dataListOptions";
import { FormPropertyInitialValues } from "../../context/context";

export const saveOrDeleteOptionAnswer = (
    { onUpdate, onDelete }: Pick<FormPropertyInitialValues, "onUpdate" | "onDelete">,
    answerKey: Required<DeleteProperty>,
    option: DataListOption | null | undefined,
    isGenericValue?: boolean,
) => {
    if (!option) {
        onDelete(answerKey);
        return;
    }

    onUpdate({
        ...answerKey,
        value: getOptionValue(option),
        isGenericValue,
        dataListOptionCodes: getOptionCodes([option]),
    });
};
